<main class="flex h-screen flex-col items-center justify-center">
  <h1 class="text-9xl font-extrabold tracking-widest">404</h1>
  <div class="rounded bg-orange-400 px-2 text-sm">Page Not Found</div>
</main>
